// Rene funksjoner som adminsiden bruker til å redigere et katalogutkast. De muterer ikke argumentene.

const ASCII = { 'æ': 'ae', 'ø': 'o', 'å': 'a' };

// Nøkkel av navn: ASCII, små bokstaver, understrek, unik mot `taken`.
export function slugKey(label, taken) {
  const base = String(label).toLowerCase()
    .replace(/[æøå]/g, (c) => ASCII[c])
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 36) || 'ny';
  let key = base;
  let n = 2;
  while (taken.includes(key)) key = `${base}_${n++}`;
  return key;
}

// Flytter element `index` ett steg (dir -1 = opp, 1 = ned) og nummererer fra 1.
export function moveItem(items, index, dir) {
  const sorted = [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const target = index + dir;
  if (target >= 0 && target < sorted.length) {
    [sorted[index], sorted[target]] = [sorted[target], sorted[index]];
  }
  return sorted.map((item, i) => ({ ...item, order: i + 1 }));
}

const nextOrder = (items) => items.reduce((max, i) => Math.max(max, i.order ?? 0), 0) + 1;

export function addType(catalog, label) {
  const key = slugKey(label, catalog.types.map((t) => t.key));
  const type = {
    key, label: label.trim(), icon: 'pile', active: true, order: nextOrder(catalog.types), priceFactor: 1.0,
    defaultEquipment: [], supportsBags: false, subLabel: '', subRequired: false, options: [],
  };
  return { ...catalog, types: [...catalog.types, type] };
}

export function addOption(catalog, typeKey, label) {
  return {
    ...catalog,
    types: catalog.types.map((t) => {
      if (t.key !== typeKey) return t;
      const key = slugKey(label, t.options.map((o) => o.key));
      return { ...t, options: [...t.options, { key, label: label.trim(), active: true, order: nextOrder(t.options) }] };
    }),
  };
}

// Nøkkelen er permanent og ignoreres i patch.
export function updateType(catalog, typeKey, patch) {
  const { key: _ignored, ...safe } = patch; // eslint-disable-line no-unused-vars
  return { ...catalog, types: catalog.types.map((t) => (t.key === typeKey ? { ...t, ...safe } : t)) };
}

export function updateOption(catalog, typeKey, optionKey, patch) {
  const { key: _ignored, ...safe } = patch; // eslint-disable-line no-unused-vars
  return {
    ...catalog,
    types: catalog.types.map((t) => (t.key !== typeKey ? t : {
      ...t, options: t.options.map((o) => (o.key === optionKey ? { ...o, ...safe } : o)),
    })),
  };
}

// Bytter ut options (etter flytting) for én type
export function setOptions(catalog, typeKey, options) {
  return { ...catalog, types: catalog.types.map((t) => (t.key === typeKey ? { ...t, options } : t)) };
}

export function setTypes(catalog, types) {
  return { ...catalog, types };
}
